import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/practice/loadscreenview", vo, successCallback, failureCallback);
    },
    updateUnitResult: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/practice/updateunitresult", vo, successCallback, failureCallback);
    },
    restart: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/practice/restart", vo, successCallback, failureCallback);
    },
    complete: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/practice/complete", vo, successCallback, failureCallback);
    },
    nextUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/practice/nextunit", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
